<template>

    <div><!--    投料-->
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="tasknum" :label="$t('promanagement_task_order_number')" >
                    <el-input  v-model="formData.tasknum" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="bmname" :label="$t('form_workshop_department')" >
                    <el-input  v-model="formData.bmname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="tldate" :label="$t('promanagement_feeding_date')" >
                    <el-input  v-model="formData.tldate" disabled>
                    </el-input>
                </el-form-item>
            </div>
            <div style="margin-bottom: 20px">
                <el-table class="table"
                          border
                          show-summary
                          ref="multipleTable"
                          :data="tableData"
                          height="290"
                          size="mini"
                          :key="tableId"
                          :row-class-name="tableRowClassName"
                          :summary-method="getSummaries"
                          tooltip-effect="dark">
                    <el-table-column
                            :label="$t('form_serial_number')"
                            align="left"
                            type="index"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_gsname"
                            :label="$t('form_goods_rights_company')"
                            width=""
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_pzname"
                            :label="$t('form_product_name')"
                            show-overflow-tooltip>
                    </el-table-column>
                   <!-- <el-table-column
                            align="left"
                            prop="vc_no"
                            :label="$t('form_batch_number')"
                    width="200"
                            show-overflow-tooltip>
                    </el-table-column>-->
                    <el-table-column
                            v-if="i_id!=0"
                            align="left"
                            prop="f_innum"
                            :label="$t('promanagement_quantity_of_feeding_materials')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="vc_unit"
                            :label="$t('form_metering')"
                            width="80"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="left"
                            prop="kcsl"
                            :label="$t('form_inventory_quantity')"
                            width=""
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            v-if="i_id==0"
                            align="left"
                            prop="f_innum"
                            :label="$t('promanagement_quantity_of_feeding_materials')"
                            width="110">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_innum'" :rules="formRules.f_num">
                                <el-input-number :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_innum" @change="tlChange(scope.row,scope.$index)"></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_id==0"
                            align="left"
                            prop="f_innum_zb"
                            :label="$t('promanagement_100%_discount_quantity')"
                            width="110">
                        <template slot-scope="scope">
                            <el-form-item class="tableForm-item" :prop="'tableData.'+scope.$index+'.f_innum_zb'" :rules="formRules.f_innum_zb">
                                <el-input-number :controls="false" :min="0" :precision="$setPrecision.quantityPrecision" class="changeinput" size="mini" v-model="scope.row.f_innum_zb"></el-input-number>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="i_id!=0"
                            align="left"
                            prop="f_innum_zb"
                            :label="$t('promanagement_100%_discount_quantity')"
                            width="110">
                    </el-table-column>
                    <el-table-column align="center"  width="50"  v-if="i_id==0">
                        <template slot="header" slot-scope="scope">
                            <el-popover
                                    class="pop"
                                    placement="bottom-end"
                                    width="1000"
                                    trigger="manual"
                                    v-model="visible">
                                <template>
                                    <product-details v-if="visible==true" :productDetails="productDetails" @closePop="closePop" @transValue="transValue"></product-details>
                                </template>
                                <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                            </el-popover>
                        </template>
                        <template  slot-scope="scope">
                            <div class="iconminus">
                                <span class="minus" @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-form-item class="form-title" prop="vc_note" :label="$t('promanagement_on_duty_log')" >
                <el-input  v-model="formData.vc_note" :disabled="chakan">
                </el-input>
            </el-form-item>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_input_person')" >
                    <el-input  v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('form_enter_time')" >
                    <el-input  v-model="formData.date" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('promanagement_accountingTime')" >
                    <el-input  v-model="formData.dt_accounttime" disabled>
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center" v-if="!chakan">
            <el-button type="primary" @click="saveForm" :disabled="disabled" :class="baseerp+'btn'" size="small">{{$t('button_save')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
            <!--            <el-button type="primary" @click="toApprove" v-if="state==0" :disabled="disabled" :class="baseerp+'btn'">提交审批</el-button>-->
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import ProductDetails from "./ProductDetails";
    export default {
        name: "FeedingForm",
        components: {ProductDetails},
        props:{
            feeding:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                formData:{
                    tasknum:"",
                    tldate:"",
                    bmname:"",
                    vc_note:"",
                    vc_lruname:sessionStorage.getItem("lruname"),
                    date:"",
                    tableData:[],
                },
                formRules:{
                },
                tableData:[],
                visible:false,
                isbtn:false,
                productDetails:{},
                disabled:false,
                edit:false,
                chakan:false,
                i_pid:0,
                i_id:0,//新增
                state:0,
                i_rwid:0,
                index:0,
                pageSize:1,
                baseerp:"",
                form:{},
                editForm:{},
                date:'',
                tableId:0,
                mid:0,
            }
        },
        watch: {
            feeding: {
                handler() {
                    if (this.feeding) {
                        //console.log("this.feeding",this.feeding)
                        this.mid=this.feeding.i_mid;
                        this.pageSize=this.feeding.page_size;
                        this.i_id=this.feeding.i_id;
                        let dtnowtime = `${this.feeding.taskDa.dt_createtime.slice(0, 4)}-${this.feeding.taskDa.dt_createtime.slice(4, 6)}-${this.feeding.taskDa.dt_createtime.slice(6, 8)}`;
                        let dtendtime = `${this.feeding.taskDa.dt_endtime.slice(0, 4)}-${this.feeding.taskDa.dt_endtime.slice(4, 6)}-${this.feeding.taskDa.dt_endtime.slice(6, 8)} 23:59:59`;
                        if (this.feeding.i_id==0){
                            this.getDateYYYYMMddHHMMSS();
                            this.form=this.feeding.taskDa;
                            // console.log("this.form",this.form)
                            this.productDetails=this.feeding.taskDa;
                            this.productDetails.i_mid=this.mid;
                            this.productDetails.selected=[];
                            this.edit=false;
                            this.chakan=false;
                            this.formData={
                                tasknum:this.form.vc_pno,
                                tldate:this.date,
                                date:this.date,
                                bmname:this.form.vc_cjname,
                                vc_note:'',
                                vc_lruname:sessionStorage.getItem("lruname"),
                                tableData:[],
                                dt_accounttime:this.feeding.jz==false?dtendtime:dtnowtime,
                            };
                            /*this.tableData=[
                                {vc_gsname:"1",f_innum:2.35,f_innum_zb:2.35},
                                {vc_gsname:"13",f_innum:2.63,f_innum_zb:2.35},
                                {vc_gsname:"12",f_innum:245.3,f_innum_zb:2.35},
                                {vc_gsname:"e1",f_innum:2.543,f_innum_zb:2.35},
                                {vc_gsname:"r1",f_innum:2.363,f_innum_zb:2.35},],*/

                            // console.log( "this.feeding",this.formData);
                        }else {
                            if (this.feeding.titleID=="zxth"){
                                this.chakan=true;
                            }else {
                                this.chakan=false;
                            }
                        //    编辑

                            this.edit=true;
                            this.isbtn=true;
                            this.editForm=this.feeding.value;
                            this.form=this.feeding.taskDa;
                            this.getFeedingDetails();
                        }
                        // console.log(this.feeding, "this.feeding",this.editForm);
                    }
                },
                immediate: true,
                deep: true
            }
        },
        mounted() {
            this.baseerp=baseerp;
        },
        methods: {
            //查看
            async getFeedingDetails(){
                let param={
                    i_mid:this.mid,
                    i_pid:this.editForm.i_pid,
                };
                let res=await API.getFeedingDetails(param);
                if(res.code==1){
                    this.formData={
                        tasknum:res.data.vc_scno,
                        tldate:res.data.dt_tltime,
                        bmname:res.data.vc_cjname,
                        vc_note:res.data.vc_note,
                        vc_lruname:res.data.vc_lruname,
                        date:res.data.dt_createtime,
                        dt_accounttime:res.data.dt_accounttime,
                        tableData:res.data.details,
                    };
                    this.tableData=res.data.details;
                    this.i_id=res.data.i_id;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //合计
            getSummaries(param) {
                const { columns, data } = param;
                const len = columns.length;
                const sums = [];
                columns.forEach((column, index) => {
                    // console.log(column,"column")
                    if (index === 0) {
                        // sums[index] = '总计'
                        sums[index] = this.$t('form_total')
                    // } else if (column.label=="投料数量") {
                    } else if (column.property=="f_innum") {
                        const values = data.map(item => Number(item[column.property]))
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                                const value = Number(curr)
                                if (!isNaN(value)) {
                                    // return (prev + curr).Math.round((prev + curr)*10000)/10000;
                                    let hj=prev + curr;
                                    // let zh=hj.toFixed(2);
                                    if (isNaN(hj)) {
                                        return;
                                    }
                                    let zh = Math.round(hj*100000)/100000;
                                    // console.log(zh,"zh")
                                    return zh;
                                } else {
                                    return prev
                                }
                            }, 0)
                        } else {
                            sums[index] = 'N/A'
                        }
                    } else {
                        sums[index] = ''
                    }
                })
                return sums
            },
            popShow(){
                this.visible=true
                //console.log(this.visible)
                if (this.visible==true){
                    this.isbtn=true
                }
            },
            closePop(){
                this.visible=false;
                this.isbtn=false;
            },
            //产品列表
            transValue(value){

                /*let arr=[];
                if ( this.formData.tableData.length>0){

                }else {
                     arr=[...value];
                }*/
                let arr=[...this.tableData,...value];
                // console.log(value,"------------")

                //console.log(arr,"arrrrrrrrrrrrr")
                /*const vc_pzid='vc_pzid';
                const vc_no='vc_no';
                const i_scid='i_scid';
                //console.log(item,"--item--",next)
                const newArr = arr.reduce((all,next)=>all.some((item)=>item[vc_pzid]==next[vc_pzid])?all:[...all,next],[]);
                const newArr2 = newArr.reduce((all,next)=>all.some((item)=>item[vc_no]==next[vc_no])?all:[...all,next],[]);
                const newArr3 = newArr2.reduce((all,next)=>all.some((item)=>item[i_scid]==next[i_scid])?all:[...all,next],[]);

*/
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.vc_unique] ? '' : hash[next.vc_unique] = true && item.push(next);
                    return item
                }, []);
                this.formData.tableData=arr;
                this.tableData=arr;
                this.productDetails.selected=this.tableData;
                //console.log("**arr**",newArr3)
            },
            deleteRow(value,index){
                this.index=index;
                this.tableData.splice(this.index,1);
                // console.log(value,"-----")
            },
            cancel(){
                //console.log(this.pageSize,"------")
                this.visible=false;
                this.$emit('close');

                //this.$emit('getPickingReqList')
            },
            tlChange(val,index){
                if (this.tableData[index].kcsl<val.f_innum){
                    this.$message.error(this.$t('promanagement_the_feeding_shall_not_exceed_the_inventory_level'))
                    this.tableData[index].f_innum=this.tableData[index].kcsl;
                }
                this.tableData[index].f_innum_zb=this.tableData[index].f_innum;
                // this.tableData[index].f_syzx=this.$math.subtract(this.tableData[index].kcsl,this.tableData[index].f_innum);
                this.tableId=Math.random();
            },
            //保存
            async saveForm(){

                let details = this.tableData.filter(item=>item.f_innum!=0);
                if (details.length==0){
                    this.$message.error(this.$t('promanagement_please_add_product'));
                    return ;
                }
                this.disabled=true;
                let param={
                    i_mid: this.mid,
                    i_id:this.i_id,
                    i_rwid:this.form.i_id,
                    vc_scno:this.formData.tasknum,
                    i_gsid:this.form.i_gsid,
                    i_cjid:this.form.i_cjid,
                    i_ckid:this.form.i_ckid,
                    i_pzid:this.form.i_pzid,
                    i_lruid:sessionStorage.getItem("userid"),
                    vc_lruname:sessionStorage.getItem("lruname"),
                    vc_note:this.formData.vc_note,
                    details:details,
                    dt_accounttime:this.formData.dt_accounttime,
                };
                let res=await API.saveFeeding(param);
                if(res.code==1){
                    this.$message.success(res.message);

                    this.visible=false;
                    this.$emit('getConsumeList',this.pageSize)
                    // this.$emit('addLine',this.pageSize)
                    this.cancel();
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.date=`${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },
            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
/deep/{
    .danger-row{
        color: #999;
    }
    .el-table__footer-wrapper {
        position: absolute !important;
        bottom: 0;
    }
    .el-table__body-wrapper{
        height: 215px !important;
    }
    /*.el-table::after{
        position:relative !important;
    }*/
}
</style>